import { LogoMark } from "./Logo";

export const EmblemFallback = () => (
  <div className="absolute inset-0 flex items-center justify-center" data-testid="hero-3d-fallback">
    <div className="relative w-[78%] max-w-[520px] aspect-square">
      <div className="absolute inset-0 rounded-full border border-[#0066ff]/30 spin-slow" style={{ borderStyle: "dashed" }} />
      <div className="absolute inset-[9%] rounded-full border border-[#d4af37]/50 spin-rev" />
      <div className="absolute inset-[18%] rounded-full bg-[radial-gradient(circle,rgba(0,240,255,0.18),transparent_65%)]" />
      <LogoMark className="absolute inset-[30%] w-[40%] h-[40%]" />
    </div>
  </div>
);

export function hasWebGL() {
  try {
    const c = document.createElement("canvas");
    return Boolean(window.WebGLRenderingContext && (c.getContext("webgl2") || c.getContext("webgl")));
  } catch (e) {
    return false;
  }
}
